import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog mw-1000px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "btn btn-sm btn-icon btn-active-color-primary hidden",
  "data-bs-dismiss": "modal",
  title: "Sign-out",
  style: {"display":"none"}
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body scroll-y m-5" }
const _hoisted_12 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_13 = { class: "stepper-nav py-5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "stepper-item current",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Insurance Info ")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " SealPro Activation Code ", -1)
const _hoisted_17 = {
  key: 1,
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Network Info ", -1)
const _hoisted_19 = {
  key: 2,
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Coverage Info ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Confirmation ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Completed ")
], -1)
const _hoisted_23 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_24 = { class: "w-100" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Below are the details for your Insurance coverage ")
], -1)
const _hoisted_26 = { class: "row mb-10" }
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your First Name"
  })
], -1)
const _hoisted_30 = { class: "position-relative" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "col-md-6 fv-row" }
const _hoisted_34 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", null, "Middle Name")
], -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-md-6 fv-row" }
const _hoisted_39 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Last Name", -1)
const _hoisted_41 = { class: "position-relative" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-md-6 fv-row" }
const _hoisted_45 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Birth Date", -1)
const _hoisted_47 = { class: "position-relative" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "col-md-6 fv-row" }
const _hoisted_51 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country of Nationality", -1)
const _hoisted_53 = { class: "position-relative" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "col-md-6 fv-row" }
const _hoisted_57 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Job Classification", -1)
const _hoisted_59 = { class: "position-relative" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-10" }
const _hoisted_63 = { class: "col-md-6 fv-row" }
const _hoisted_64 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Mobile Number", -1)
const _hoisted_66 = { class: "position-relative" }
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "col-md-6 fv-row" }
const _hoisted_70 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Email", -1)
const _hoisted_72 = { class: "position-relative" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Your address ")
], -1)
const _hoisted_76 = { class: "col-md-6 fv-row" }
const _hoisted_77 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Block Number and Street", -1)
const _hoisted_79 = { class: "position-relative" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "col-md-6 fv-row" }
const _hoisted_83 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "Name of Building(Optional)", -1)
const _hoisted_85 = { class: "position-relative" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "col-md-6 fv-row" }
const _hoisted_89 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_90 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Unit Number (Optional)", -1)
const _hoisted_91 = { class: "position-relative" }
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = { class: "col-md-6 fv-row" }
const _hoisted_95 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_96 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "City", -1)
const _hoisted_97 = { class: "position-relative" }
const _hoisted_98 = { class: "fv-plugins-message-container" }
const _hoisted_99 = { class: "fv-help-block" }
const _hoisted_100 = { class: "col-md-6 fv-row" }
const _hoisted_101 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_102 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Postal Code", -1)
const _hoisted_103 = { class: "position-relative" }
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = { class: "col-md-6 fv-row" }
const _hoisted_107 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_108 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country", -1)
const _hoisted_109 = { class: "position-relative" }
const _hoisted_110 = { class: "fv-plugins-message-container" }
const _hoisted_111 = { class: "fv-help-block" }
const _hoisted_112 = { class: "col-md-6 fv-row" }
const _hoisted_113 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_114 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Province", -1)
const _hoisted_115 = { class: "position-relative" }
const _hoisted_116 = { class: "fv-plugins-message-container" }
const _hoisted_117 = { class: "fv-help-block" }
const _hoisted_118 = { class: "col-md-6 fv-row" }
const _hoisted_119 = { class: "d-flex flex-column mt-8 fv-row" }
const _hoisted_120 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createTextVNode("Please "),
  /*#__PURE__*/_createVNode("u", null, "upload"),
  /*#__PURE__*/_createTextVNode(" a parental consent.")
], -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Beneficiary Details ")
], -1)
const _hoisted_122 = { class: "row mb-10" }
const _hoisted_123 = { class: "col-md-6 fv-row" }
const _hoisted_124 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_125 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary First Name"
  })
], -1)
const _hoisted_126 = { class: "fv-plugins-message-container" }
const _hoisted_127 = { class: "fv-help-block" }
const _hoisted_128 = { class: "col-md-6 fv-row" }
const _hoisted_129 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_130 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary Middle Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary Middle Name"
  })
], -1)
const _hoisted_131 = { class: "fv-plugins-message-container" }
const _hoisted_132 = { class: "fv-help-block" }
const _hoisted_133 = { class: "col-md-6 fv-row" }
const _hoisted_134 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_135 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Last Name", -1)
const _hoisted_136 = { class: "position-relative" }
const _hoisted_137 = { class: "fv-plugins-message-container" }
const _hoisted_138 = { class: "fv-help-block" }
const _hoisted_139 = { class: "col-md-6 fv-row" }
const _hoisted_140 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_141 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Birth Date", -1)
const _hoisted_142 = { class: "position-relative" }
const _hoisted_143 = { class: "fv-plugins-message-container" }
const _hoisted_144 = { class: "fv-help-block" }
const _hoisted_145 = { class: "col-md-6 fv-row" }
const _hoisted_146 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_147 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Mobile Number", -1)
const _hoisted_148 = { class: "position-relative" }
const _hoisted_149 = { class: "fv-plugins-message-container" }
const _hoisted_150 = { class: "fv-help-block" }
const _hoisted_151 = { class: "col-md-6 fv-row" }
const _hoisted_152 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_153 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Relationship With Insured", -1)
const _hoisted_154 = { class: "position-relative" }
const _hoisted_155 = /*#__PURE__*/_createVNode("option", null, "Select Relationship", -1)
const _hoisted_156 = /*#__PURE__*/_createVNode("option", {
  label: "Spouse",
  value: "Spouse"
}, "Spouse", -1)
const _hoisted_157 = /*#__PURE__*/_createVNode("option", {
  label: "Child",
  value: "Child"
}, "Child", -1)
const _hoisted_158 = /*#__PURE__*/_createVNode("option", {
  label: "Parent",
  value: "Parent"
}, "Parent", -1)
const _hoisted_159 = /*#__PURE__*/_createVNode("option", {
  label: "Sibling",
  value: "Sibling"
}, "Sibling", -1)
const _hoisted_160 = /*#__PURE__*/_createVNode("option", {
  label: "Others (Blood-related, Relative)",
  value: "Others"
}, "Others (Blood-related, Relative)", -1)
const _hoisted_161 = { class: "fv-plugins-message-container" }
const _hoisted_162 = { class: "fv-help-block" }
const _hoisted_163 = { class: "col-md-12 fv-row" }
const _hoisted_164 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_165 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Terms and Conditions", -1)
const _hoisted_166 = { class: "position-relative" }
const _hoisted_167 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you are confirming that you have taken the time to read, comprehend, and review the terms and conditions outlined in the linked insurance policy and that you hereby acknowledge that you understood, and agreed to the terms and conditions of the said insurance policy including the general exclusions, claim requirements, and other sections of the policy.", -1)
const _hoisted_168 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you also confirm that the personal information that you submitted are true and correct of your own knowledge. ", -1)
const _hoisted_169 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you hereby authorize Orbix Victus International Inc. & Stronghold Insurance Company Inc. to collect and store your data. Data such as but not limited to, your full name, nationality, mobile number, and other relevant information, using electronic or automated means, shall be stored within the period allowed under applicable laws, rules and regulations, for the purpose of processing your insurance policy.", -1)
const _hoisted_170 = { class: "row mb-5 mt-5" }
const _hoisted_171 = { class: "form-check-label col-md-10" }
const _hoisted_172 = /*#__PURE__*/_createVNode("span", { class: "form-check-sign" }, null, -1)
const _hoisted_173 = /*#__PURE__*/_createTextVNode(" I have read the Terms and Conditions. I agree and I want to proceed! ")
const _hoisted_174 = {
  key: 0,
  "data-kt-stepper-element": "content"
}
const _hoisted_175 = { class: "w-100" }
const _hoisted_176 = { class: "row mb-10" }
const _hoisted_177 = { class: "col-md-12 fv-row" }
const _hoisted_178 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_179 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "SealPro Code"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_180 = { class: "fv-plugins-message-container" }
const _hoisted_181 = { class: "fv-help-block" }
const _hoisted_182 = {
  key: 1,
  "data-kt-stepper-element": "content"
}
const _hoisted_183 = { class: "w-100" }
const _hoisted_184 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Network Info "),
    /*#__PURE__*/_createVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" })
], -1)
const _hoisted_185 = { class: "row mb-10" }
const _hoisted_186 = { class: "col-md-6 fv-row" }
const _hoisted_187 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_188 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Sponsor ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_189 = { class: "fv-plugins-message-container" }
const _hoisted_190 = { class: "fv-help-block" }
const _hoisted_191 = { class: "col-md-6 fv-row" }
const _hoisted_192 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_193 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Upline ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_194 = { class: "fv-plugins-message-container" }
const _hoisted_195 = { class: "fv-help-block" }
const _hoisted_196 = { class: "col-md-12 fv-row" }
const _hoisted_197 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_198 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Position"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_199 = /*#__PURE__*/_createVNode("option", {
  label: "Select Position",
  value: ""
}, null, -1)
const _hoisted_200 = /*#__PURE__*/_createVNode("option", {
  label: "Left",
  value: "L"
}, null, -1)
const _hoisted_201 = /*#__PURE__*/_createVNode("option", {
  label: "Right",
  value: "R"
}, null, -1)
const _hoisted_202 = { class: "fv-plugins-message-container" }
const _hoisted_203 = { class: "fv-help-block" }
const _hoisted_204 = { class: "col-md-6 fv-row" }
const _hoisted_205 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_206 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "User ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_207 = { class: "fv-plugins-message-container" }
const _hoisted_208 = { class: "fv-help-block" }
const _hoisted_209 = { class: "col-md-6 fv-row" }
const _hoisted_210 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_211 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Security PIN"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_212 = { class: "fv-plugins-message-container" }
const _hoisted_213 = { class: "fv-help-block" }
const _hoisted_214 = {
  key: 2,
  "data-kt-stepper-element": "content"
}
const _hoisted_215 = { class: "w-100" }
const _hoisted_216 = { class: "row mb-10" }
const _hoisted_217 = { class: "col-xxl-12" }
const _hoisted_218 = { class: "card" }
const _hoisted_219 = { class: "card-body py-3" }
const _hoisted_220 = {
  key: 0,
  class: "timeline-content mb-10 mt-n1"
}
const _hoisted_221 = { class: "pe-3 mb-5" }
const _hoisted_222 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_223 = { class: "overflow-auto pb-5" }
const _hoisted_224 = { class: "d-flex  align-items-center border border-dashed border-gray-300 rounded  min-w-750px px-7 py-3 mb-5" }
const _hoisted_225 = {
  key: 1,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_226 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_227 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Invalid Registration code. Cannot select coverages available </h4><div class=\"fs-6 text-gray-600\"><a href=\"javascript:;\" class=\"fw-bolder\"></a></div></div></div>", 1)
const _hoisted_228 = { key: 2 }
const _hoisted_229 = { class: "pe-3 mb-5" }
const _hoisted_230 = /*#__PURE__*/_createVNode("div", { class: "fs-5 fw-bold mb-2" }, " Coverages to be encoded ", -1)
const _hoisted_231 = { class: "d-flex  align-items-center border border-dashed border-gray-300 rounded  min-w-750px px-7 py-3 mb-5" }
const _hoisted_232 = {
  key: 0,
  href: "javascript:;"
}
const _hoisted_233 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_234 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6"
}
const _hoisted_235 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_236 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_237 = { class: "fw-bold" }
const _hoisted_238 = { class: "text-gray-800 fw-bolder" }
const _hoisted_239 = {
  key: 0,
  class: "text-gray-800 fw-bolder"
}
const _hoisted_240 = {
  key: 1,
  class: "text-gray-800 fw-bolder"
}
const _hoisted_241 = /*#__PURE__*/_createVNode("div", { class: "fs-6 text-gray-600" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "javascript:;",
    class: "fw-bolder"
  })
], -1)
const _hoisted_242 = { "data-kt-stepper-element": "content" }
const _hoisted_243 = { class: "w-100" }
const _hoisted_244 = { class: "mb-0" }
const _hoisted_245 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_246 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_247 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Please wait... verifying data... </h4><div class=\"fs-6 text-gray-600\"><a href=\"javascript:;\" class=\"fw-bolder\"></a></div></div></div>", 1)
const _hoisted_248 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\"><div class=\"w-100 text-center\"><h1 class=\"fw-bolder text-dark mb-3\"></h1><div class=\"text-muted fw-bold fs-3\"> Submitting your application. Please wait </div><div class=\"text-center px-4 py-15\"><img src=\"media/illustrations/todo.png\" alt=\"\" class=\"mw-100 mh-150px\"></div></div></div>", 1)
const _hoisted_249 = { class: "d-flex flex-stack pt-15" }
const _hoisted_250 = { class: "me-2" }
const _hoisted_251 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_252 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_253 = { key: 0 }
const _hoisted_254 = { class: "indicator-label" }
const _hoisted_255 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_256 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_257 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_258 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_259 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_260 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_ConfirmRegisterSealProEncode = _resolveComponent("ConfirmRegisterSealProEncode")

  return (_openBlock(), _createBlock("div", {
    class: "modal fade",
    id: _ctx.sealpro_encode_modal,
    tabindex: "-1",
    "aria-hidden": "true",
    "data-bs-backdrop": _ctx.allowClose,
    "data-bs-keyboard": _ctx.allowClose
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          ((_ctx.isAddAccount && !_ctx.isRenewal))
            ? (_openBlock(), _createBlock("h2", _hoisted_4, "Add " + _toDisplayString(_ctx.hasOVIPackage == true ? 'EC/EDPLAN/' : '') + "OVI Account/Package with SEALPRO", 1))
            : _createCommentVNode("", true),
          ((!_ctx.isAddAccount && !_ctx.isRenewal))
            ? (_openBlock(), _createBlock("h2", _hoisted_5, "Encode SealPro Coverage ( " + _toDisplayString(_ctx.coverage_transtype) + " ) ", 1))
            : _createCommentVNode("", true),
          (_ctx.isRenewal)
            ? (_openBlock(), _createBlock("h2", _hoisted_6, "RENEW INSURANCE COVERAGE "))
            : _createCommentVNode("", true),
          (!_ctx.allowClose)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logOut()))
                }, [
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Sign-out.svg" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              (_ctx.inputActivationDetail)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAddAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCoverageInfoTabOpen)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _hoisted_20
                  ]))
                : _createCommentVNode("", true),
              _hoisted_21,
              _hoisted_22
            ]),
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              ref: "sealproencodecoverage_form",
              onSubmit: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("div", _hoisted_30, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_firstName"
                          }),
                          _createVNode("div", _hoisted_31, [
                            _createVNode("div", _hoisted_32, [
                              _createVNode(_component_ErrorMessage, { name: "insured_firstName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "insured_middleName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_36, [
                          _createVNode("div", _hoisted_37, [
                            _createVNode(_component_ErrorMessage, { name: "insured_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_lastName"
                          }),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "insured_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_birthday",
                            value: _ctx.insured_birthday,
                            onBlur: _cache[2] || (_cache[2] = ($event: any) => {_ctx.blurBirthdate($event, _ctx.otherArgument);})
                          }, null, 8, ["value"]),
                          _createVNode("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode("div", _hoisted_53, [
                          _createVNode(_component_Field, {
                            name: "address_country2",
                            modelValue: _ctx.formData.address_country2,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.address_country2 = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countries) + " ", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_54, [
                            _createVNode("div", _hoisted_55, [
                              _createVNode(_component_ErrorMessage, { name: "address_country2" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_56, [
                      _createVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createVNode("div", _hoisted_59, [
                          _createVNode(_component_Field, {
                            name: "job_classification",
                            modelValue: _ctx.formData.job_classification,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.job_classification = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.job_classification_options_list, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.job_classification_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_60, [
                            _createVNode("div", _hoisted_61, [
                              _createVNode(_component_ErrorMessage, { name: "job_classification" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_62, [
                    _createVNode("div", _hoisted_63, [
                      _createVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _createVNode("div", _hoisted_66, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_mobileNumber",
                            modelValue: _ctx.formData.insured_mobileNumber,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.insured_mobileNumber = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_67, [
                            _createVNode("div", _hoisted_68, [
                              _createVNode(_component_ErrorMessage, { name: "insured_mobileNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode("div", _hoisted_72, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_email",
                            modelValue: _ctx.formData.insured_email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.insured_email = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_73, [
                            _createVNode("div", _hoisted_74, [
                              _createVNode(_component_ErrorMessage, { name: "insured_email" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_75,
                    _createVNode("div", _hoisted_76, [
                      _createVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode("div", _hoisted_79, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_blockAndStreet",
                            modelValue: _ctx.formData.address_blockAndStreet,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.address_blockAndStreet = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_80, [
                            _createVNode("div", _hoisted_81, [
                              _createVNode(_component_ErrorMessage, { name: "address_blockAndStreet" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_82, [
                      _createVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createVNode("div", _hoisted_85, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_nameOfBuilding",
                            modelValue: _ctx.formData.address_nameOfBuilding,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.address_nameOfBuilding = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_86, [
                            _createVNode("div", _hoisted_87, [
                              _createVNode(_component_ErrorMessage, { name: "address_nameOfBuilding" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_88, [
                      _createVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createVNode("div", _hoisted_91, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_unitNumber",
                            maxlength: "50",
                            modelValue: _ctx.formData.address_unitNumber,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.address_unitNumber = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_92, [
                            _createVNode("div", _hoisted_93, [
                              _createVNode(_component_ErrorMessage, { name: "address_unitNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_94, [
                      _createVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createVNode("div", _hoisted_97, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_city",
                            modelValue: _ctx.formData.address_city,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.address_city = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_98, [
                            _createVNode("div", _hoisted_99, [
                              _createVNode(_component_ErrorMessage, { name: "address_city" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_100, [
                      _createVNode("div", _hoisted_101, [
                        _hoisted_102,
                        _createVNode("div", _hoisted_103, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_postalCode",
                            modelValue: _ctx.formData.address_postalCode,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.address_postalCode = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_104, [
                            _createVNode("div", _hoisted_105, [
                              _createVNode(_component_ErrorMessage, { name: "address_postalCode" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_106, [
                      _createVNode("div", _hoisted_107, [
                        _hoisted_108,
                        _createVNode("div", _hoisted_109, [
                          _createVNode(_component_Field, {
                            name: "address_country",
                            modelValue: _ctx.formData.address_country,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.address_country = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select",
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getCities(_ctx.formData.address_country)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countries) + " ", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_110, [
                            _createVNode("div", _hoisted_111, [
                              _createVNode(_component_ErrorMessage, { name: "address_country" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_112, [
                      _createVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _createVNode("div", _hoisted_115, [
                          _createVNode(_component_Field, {
                            name: "address_province",
                            modelValue: _ctx.formData.address_province,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.address_province = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.zone_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_116, [
                            _createVNode("div", _hoisted_117, [
                              _createVNode(_component_ErrorMessage, { name: "address_province" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_118, [
                      _createVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _createVNode("input", {
                          type: "file",
                          name: "parental_consent",
                          id: "parental_consent",
                          ref: "parental_consent",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.upload($event)))
                        }, null, 544)
                      ])
                    ], 512), [
                      [_vShow, _ctx.displayUploadParentalConsent]
                    ])
                  ]),
                  _hoisted_121,
                  _createVNode("div", _hoisted_122, [
                    _createVNode("div", _hoisted_123, [
                      _createVNode("div", _hoisted_124, [
                        _hoisted_125,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_firstName",
                          maxlength: "50",
                          modelValue: _ctx.formData.beneficiary_firstName,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.beneficiary_firstName = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_126, [
                          _createVNode("div", _hoisted_127, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_firstName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_128, [
                      _createVNode("div", _hoisted_129, [
                        _hoisted_130,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_middleName",
                          maxlength: "50",
                          modelValue: _ctx.formData.beneficiary_middleName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.beneficiary_middleName = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_131, [
                          _createVNode("div", _hoisted_132, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_133, [
                      _createVNode("div", _hoisted_134, [
                        _hoisted_135,
                        _createVNode("div", _hoisted_136, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_lastName",
                            modelValue: _ctx.formData.beneficiary_lastName,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.beneficiary_lastName = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_137, [
                            _createVNode("div", _hoisted_138, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_139, [
                      _createVNode("div", _hoisted_140, [
                        _hoisted_141,
                        _createVNode("div", _hoisted_142, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_birthday",
                            modelValue: _ctx.formData.beneficiary_birthday,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.beneficiary_birthday = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_143, [
                            _createVNode("div", _hoisted_144, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_145, [
                      _createVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _createVNode("div", _hoisted_148, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_contact",
                            modelValue: _ctx.formData.beneficiary_contact,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.beneficiary_contact = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_149, [
                            _createVNode("div", _hoisted_150, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_contact" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_151, [
                      _createVNode("div", _hoisted_152, [
                        _hoisted_153,
                        _createVNode("div", _hoisted_154, [
                          _createVNode(_component_Field, {
                            name: "beneficiary_relationship",
                            modelValue: _ctx.formData.beneficiary_relationship,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.beneficiary_relationship = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_155,
                              _hoisted_156,
                              _hoisted_157,
                              _hoisted_158,
                              _hoisted_159,
                              _hoisted_160
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_161, [
                            _createVNode("div", _hoisted_162, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_relationship" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_163, [
                      _createVNode("div", _hoisted_164, [
                        _hoisted_165,
                        _createVNode("div", _hoisted_166, [
                          _hoisted_167,
                          _hoisted_168,
                          _hoisted_169,
                          _createVNode("div", _hoisted_170, [
                            _createVNode("label", _hoisted_171, [
                              _createVNode("input", {
                                class: "form-check-input",
                                id: "checkbox4",
                                type: "checkbox",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.checkBoxValidator($event);})
                              }),
                              _hoisted_172,
                              _hoisted_173
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.inputActivationDetail)
                ? (_openBlock(), _createBlock("div", _hoisted_174, [
                    _createVNode("div", _hoisted_175, [
                      _createVNode("div", _hoisted_176, [
                        _createVNode("div", _hoisted_177, [
                          _createVNode("div", _hoisted_178, [
                            _hoisted_179,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid",
                              placeholder: "",
                              name: "sealProCode",
                              maxlength: "20"
                            }),
                            _createVNode("div", _hoisted_180, [
                              _createVNode("div", _hoisted_181, [
                                _createVNode(_component_ErrorMessage, { name: "sealProCode" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAddAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_182, [
                    _createVNode("div", _hoisted_183, [
                      _hoisted_184,
                      _createVNode("div", _hoisted_185, [
                        _createVNode("div", _hoisted_186, [
                          _createVNode("div", _hoisted_187, [
                            _hoisted_188,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid",
                              placeholder: "",
                              name: "spid",
                              maxlength: "20"
                            }),
                            _createVNode("div", _hoisted_189, [
                              _createVNode("div", _hoisted_190, [
                                _createVNode(_component_ErrorMessage, { name: "spid" })
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_191, [
                          _createVNode("div", _hoisted_192, [
                            _hoisted_193,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid",
                              placeholder: "",
                              name: "upid",
                              maxlength: "20",
                              readonly: _ctx.isDisabledUPID
                            }, null, 8, ["readonly"]),
                            _createVNode("div", _hoisted_194, [
                              _createVNode("div", _hoisted_195, [
                                _createVNode(_component_ErrorMessage, { name: "upid" })
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_196, [
                          _createVNode("div", _hoisted_197, [
                            _hoisted_198,
                            _createVNode(_component_Field, {
                              name: "position",
                              modelValue: _ctx.position,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.position = $event)),
                              class: "form-select form-select-lg form-select-solid",
                              as: "select",
                              disabled: _ctx.isDisabledUPID
                            }, {
                              default: _withCtx(() => [
                                _hoisted_199,
                                _hoisted_200,
                                _hoisted_201
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"]),
                            _createVNode("div", _hoisted_202, [
                              _createVNode("div", _hoisted_203, [
                                _createVNode(_component_ErrorMessage, { name: "position" })
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_204, [
                          _createVNode("div", _hoisted_205, [
                            _hoisted_206,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid",
                              placeholder: "",
                              name: "usid",
                              maxlength: "20"
                            }),
                            _createVNode("div", _hoisted_207, [
                              _createVNode("div", _hoisted_208, [
                                _createVNode(_component_ErrorMessage, { name: "usid" })
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_209, [
                          _createVNode("div", _hoisted_210, [
                            _hoisted_211,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid",
                              placeholder: "",
                              name: "secpin",
                              maxlength: "20"
                            }),
                            _createVNode("div", _hoisted_212, [
                              _createVNode("div", _hoisted_213, [
                                _createVNode(_component_ErrorMessage, { name: "secpin" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCoverageInfoTabOpen)
                ? (_openBlock(), _createBlock("div", _hoisted_214, [
                    _createVNode("div", _hoisted_215, [
                      _createVNode("div", _hoisted_216, [
                        _createVNode("div", _hoisted_217, [
                          _createVNode("div", _hoisted_218, [
                            _createVNode("div", _hoisted_219, [
                              (_ctx.sealProMaxCoverage > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_220, [
                                    _createVNode("div", _hoisted_221, [
                                      _createVNode("div", _hoisted_222, " Active Coverages " + _toDisplayString(_ctx.numberWithCommas(_ctx.sealProMaxCoverage.toFixed(2))), 1)
                                    ]),
                                    _createVNode("div", _hoisted_223, [
                                      _createVNode("div", _hoisted_224, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeCoverage, (item, index) => {
                                          return (_openBlock(), _createBlock("div", {
                                            class: "symbol symbol-100px symbol-lg-180px symbol-fixed position-relative",
                                            key: index
                                          }, [
                                            _createVNode("img", {
                                              src: '/media/ovi_coverages/' + item.packageType + '.webp',
                                              alt: "img"
                                            }, null, 8, ["src"])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.regcodeCoverages.length <= 0 || _ctx.regcodeCoverages === undefined)
                                ? (_openBlock(), _createBlock("div", _hoisted_225, [
                                    _createVNode("span", _hoisted_226, [
                                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                                    ]),
                                    _hoisted_227
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_228, [
                                    _createVNode("div", _hoisted_229, [
                                      _hoisted_230,
                                      _createVNode("div", _hoisted_231, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regcodeCoverages, (item, index) => {
                                          return (_openBlock(), _createBlock("div", {
                                            class: [[item.sts ? 'notice d-flex bg-light-success rounded border-success border border-dashed' : ''], "symbol symbol-100px symbol-lg-180px symbol-fixed position-relative  mb-10 p-6 m-2"],
                                            onClick: ($event: any) => (_ctx.selectCoverage(index)),
                                            key: index
                                          }, [
                                            _createVNode("img", {
                                              src: '/media/ovi_coverages/' + (item.parent_id > 0 ? 'k' : '') + item.coverage_type + '.webp',
                                              alt: "img"
                                            }, null, 8, ["src"]),
                                            (item.sts)
                                              ? (_openBlock(), _createBlock("a", _hoisted_232, [
                                                  _createVNode("span", _hoisted_233, [
                                                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 10, ["onClick"]))
                                        }), 128))
                                      ]),
                                      (_ctx.totalcoverageselected > 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_234, [
                                            _createVNode("span", _hoisted_235, [
                                              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Primary-1-circle.svg" })
                                            ]),
                                            _createVNode("div", _hoisted_236, [
                                              _createVNode("div", _hoisted_237, [
                                                _createVNode("h4", _hoisted_238, " Total coverage selected is " + _toDisplayString(_ctx.numberWithCommas(_ctx.totalcoverageselected.toFixed(2))), 1),
                                                (_ctx.totalcoverageselected != (_ctx.totalcoverageselected + _ctx.sealProMaxCoverage))
                                                  ? (_openBlock(), _createBlock("h4", _hoisted_239, " Your total coverage will be " + _toDisplayString(_ctx.numberWithCommas((_ctx.totalcoverageselected + _ctx.sealProMaxCoverage).toFixed(2))), 1))
                                                  : _createCommentVNode("", true),
                                                (_ctx.totalcoverageselected + _ctx.sealProMaxCoverage > 3000000)
                                                  ? (_openBlock(), _createBlock("h4", _hoisted_240, " Coverage will exceed limit "))
                                                  : _createCommentVNode("", true),
                                                _hoisted_241
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_242, [
                _createVNode("div", _hoisted_243, [
                  _createVNode("div", _hoisted_244, [
                    (_ctx.formData.verifyingdata)
                      ? (_openBlock(), _createBlock("div", _hoisted_245, [
                          _createVNode("span", _hoisted_246, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _hoisted_247
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.verifyingdata === false)
                      ? (_openBlock(), _createBlock(_component_ConfirmRegisterSealProEncode, {
                          key: 1,
                          formdata: _ctx.formData
                        }, null, 8, ["formdata"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_248,
              _createVNode("div", _hoisted_249, [
                _createVNode("div", _hoisted_250, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_251, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                    ]),
                    _hoisted_252
                  ])
                ]),
                (_ctx.formData.verifyingdata === false && _ctx.currentStepIndex !== (_ctx.totalSteps -1))
                  ? (_openBlock(), _createBlock("div", _hoisted_253, [
                      (_ctx.currentStepIndex === _ctx.totalSteps - 2)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.formSubmit()))
                          }, [
                            _createVNode("span", _hoisted_254, [
                              _hoisted_255,
                              _createVNode("span", _hoisted_256, [
                                _createVNode(_component_inline_svg, { src: "icons/duotone/Navigation/Right-2.svg" })
                              ])
                            ]),
                            _hoisted_257
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.istncchecked == true && _ctx.currentStepIndex < 3 && _ctx.currentStepIndex !== (_ctx.totalSteps - 2) && _ctx.currentStepIndex !== (_ctx.totalSteps -1))
                        ? (_openBlock(), _createBlock("button", _hoisted_258, [
                            _hoisted_259,
                            _createVNode("span", _hoisted_260, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 544)
          ], 512)
        ])
      ])
    ])
  ], 8, ["id", "data-bs-backdrop", "data-bs-keyboard"]))
}